<template>
  <div class="money_list_page">
   <div class="page_content" ref="pageContent" :style="contentStyle">
    <!-- 顶部标题区 -->
    <div class="header">
      <img
        class="header_bg"
        :src="require('@/assets/new_adult_img/价格列表背景图.png')"
        alt="座享陪伴 舒适安心"
      />
    </div>



    <!-- 加载/失败状态 -->
    <div v-if="loading" class="loading_tip">加载中...</div>
    <div v-else-if="!moneyData" class="loading_tip">加载失败，请重试</div>

    <!-- 功能列表 -->
    <div v-else class="opt_list">
        <!-- 安全提示 -->
        <div class="safe_tip">
          <span class="safe_icon">!</span>
          <span class="safe_text">孕妇、心脑血管疾病患者或体内安装医用器械者禁止按摩</span>
        </div>
      <!-- 手机充电 -->
      <div class="opt_item" :class="{ opt_disabled: allCount > 0 }">
        <div class="opt_icon icon_charge"><img :src="require('@/assets/new_adult_img/充电.png')" alt=""></div>
        <div class="opt_content">
          <div class="opt_name">手机充电</div>
          <div class="opt_price">
            <span class="opt_price_num" :class="{ opt_price_long: String(moneyData.charge_money || '').length > 4 }">¥{{ moneyData.charge_money || '-' }}</span>
            <span class="opt_price_unit">/小时</span>
          </div>
        </div>
        <div class="opt_stepper">
          <button class="step_btn" :disabled="chargeCount <= 0 || allCount > 0" @click="decCount('charge')">−</button>
          <span class="step_num">{{ chargeCount }}</span>
          <button class="step_btn" :disabled="chargeCount >= 5 || allCount > 0" @click="incCount('charge')">+</button>
        </div>
      </div>

      <!-- 影视娱乐 -->
      <div class="opt_item" :class="{ opt_disabled: allCount > 0 }">
        <div class="opt_icon icon_media"><img :src="require('@/assets/new_adult_img/娱乐.png')" alt=""></div>
        <div class="opt_content">
          <div class="opt_name">影视娱乐</div>
          <div class="opt_price">
            <span class="opt_price_num" :class="{ opt_price_long: String(moneyData.pad_money || '').length > 4 }">¥{{ moneyData.pad_money || '-' }}</span>
            <span class="opt_price_unit">/小时</span>
          </div>
        </div>
        <div class="opt_stepper">
          <button class="step_btn" :disabled="padCount <= 0 || allCount > 0" @click="decCount('pad')">−</button>
          <span class="step_num">{{ padCount }}</span>
          <button class="step_btn" :disabled="padCount >= 5 || allCount > 0" @click="incCount('pad')">+</button>
        </div>
      </div>

      <!-- 座椅功能 -->
      <div class="opt_item" :class="{ opt_disabled: allCount > 0 }">
        <div class="opt_icon icon_chair"><img :src="require('@/assets/new_adult_img/按摩.png')" alt=""></div>
        <div class="opt_content">
          <div class="opt_name">座椅功能<span class="opt_tag">按摩、平躺、扶手加热</span></div>
          <div class="opt_price">
            <span class="opt_price_num" :class="{ opt_price_long: String(moneyData.chair_money || '').length > 4 }">¥{{ moneyData.chair_money || '-' }}</span>
            <span class="opt_price_unit">/小时</span>
          </div>
        </div>
        <div class="opt_stepper">
          <button class="step_btn" :disabled="chairCount <= 0 || allCount > 0" @click="decCount('chair')">−</button>
          <span class="step_num">{{ chairCount }}</span>
          <button class="step_btn" :disabled="chairCount >= 5 || allCount > 0" @click="incCount('chair')">+</button>
        </div>
      </div>

      <!-- 全套功能（和其他三个互斥） -->
      <div class="opt_item opt_all" :class="{ opt_disabled: chargeCount + padCount + chairCount > 0 }">
        <div class="opt_icon icon_all"><img :src="require('@/assets/new_adult_img/全套.png')" alt=""></div>
        <div class="opt_content">
          <div class="opt_name">全套功能<span class="opt_recommend">👍 推荐套餐</span></div>
          <div class="opt_price">
            <span class="opt_price_num" :class="{ opt_price_long: String(moneyData.all_moneys || '').length > 4 }">¥{{ moneyData.all_moneys || '-' }}</span>
            <span class="opt_price_unit">/小时</span>
          </div>
          <div class="opt_desc">一键全享 · 更省心 · 体验更完整</div>
        </div>
        <div class="opt_stepper">
          <button class="step_btn" :disabled="allCount <= 0 || chargeCount + padCount + chairCount > 0" @click="decCount('all')">−</button>
          <span class="step_num">{{ allCount }}</span>
          <button class="step_btn" :disabled="allCount >= 5 || chargeCount + padCount + chairCount > 0" @click="incCount('all')">+</button>
        </div>
      </div>


      <div v-if="moneyData" class="bottom_bar">
        <div class="total">
          <span>总金额：</span><span class="total_price">¥{{ totalAmount.toFixed(2) }}</span>
        </div>
        <button class="pay_btn" :disabled="totalAmount <= 0" @click="handlePay">确认付款</button>
      </div>

    </div>

    <!-- 底部公司信息（贴底） -->
    <div class="company_footer">
      <!-- 二维码图片：请将二维码命名为 qrcode.png 放到 src/assets/new_adult_img/ 下 -->
      <img class="qr_code" src="@/assets/new_adult_img/qrcode.png" alt="二维码" />
      <div class="company_info">
        <div class="company_name">江苏座享智能科技有限公司</div>
        <div class="company_addr">无锡滨湖区汇创大厦2号楼16F</div>
        <div class="company_phone">加盟咨询：400-8280-681</div>
      </div>
    </div>
   </div>

    <!-- 底部 TabBar -->
    <AdultNewTabBar />
  </div>
</template>

<script>
import axios from 'axios'
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'

export default {
  name: 'NewPageMoneyList',
  components: { AdultNewTabBar },
  data() {
    return {
      loading: false,
      moneyData: null,
      // 四个功能的选择数量，范围 0~5
      chargeCount: 0,   // 手机充电
      padCount: 0,      // 影视娱乐
      chairCount: 0,    // 座椅功能
      allCount: 0,      // 全套功能
      pageScale: 1,     // 小屏自适应缩放比例
      pageMinHeight: 0  // 内容容器最小高度(px)
    }
  },
  mounted() {
    this.getMoneyList()
    this.$nextTick(() => this.fitToScreen())
    window.addEventListener('resize', this.fitToScreen)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fitToScreen)
  },
  computed: {
    // 总金额 = 各功能 (单价 × 数量) 之和
    totalAmount() {
      if (!this.moneyData) return 0
      const charge = this.chargeCount * parseFloat(this.moneyData.charge_money || 0)
      const pad = this.padCount * parseFloat(this.moneyData.pad_money || 0)
      const chair = this.chairCount * parseFloat(this.moneyData.chair_money || 0)
      const all = this.allCount * parseFloat(this.moneyData.all_moneys || 0)
      return charge + pad + chair + all
    },
    // 内容超出可视高度时整体等比缩小，保证一屏完整展示
    contentStyle() {
      const style = {}
      if (this.pageMinHeight) style.minHeight = this.pageMinHeight + 'px'
      const s = this.pageScale
      if (s < 1) {
        style.width = (100 / s) + '%'
        style.transform = `scale(${s})`
        style.transformOrigin = 'top left'
      }
      return style
    }
  },
  methods: {
    // 自适应屏幕高度：按可视区高度计算缩放比例
    fitToScreen() {
      const el = this.$refs.pageContent
      if (!el) return
      const tabbar = this.$el.querySelector('.tabbar')
      const tabbarH = tabbar ? tabbar.offsetHeight : 58
      const avail = window.innerHeight - tabbarH
      this.pageMinHeight = avail
      this.pageScale = 1
      this.$nextTick(() => {
        const natural = el.offsetHeight
        if (natural > avail && natural > 0) {
          this.pageScale = avail / natural
        }
      })
    },
    // 获取套餐数据
    async getMoneyList() {

      this.loading = true
      try {
        const params= {
          equ_id: localStorage.getItem("text"),
        }
        const res = await axios.get('https://htapi.zxznzy.com/project/get_money_list', { params })
        if (res.data.code === 200) {
          this.moneyData = res.data.pad_pro_money_list[0]
          const old_money_list = res.data.pro_money_list[0]
          localStorage.setItem("equ_no", old_money_list.equ_no)
          localStorage.setItem("project_no", old_money_list.project_no)
          localStorage.setItem("pad_no", res.data.pad_pro_pad_no)
        } else {
          alert("接口返回异常请联系客服,赠送免费套餐")
          // alert(JSON.stringify(res.data))
          console.error('接口返回异常', res.data)
          this.moneyData = this._fallbackData()
        }
      } catch (e) {
        alert("接口返回异常请联系客服,赠送免费套餐")
        console.error('请求失败', e)
        // 跨域/网络异常时给占位数据，方便调试
        this.moneyData = this._fallbackData()
      } finally {
        this.loading = false
        this.$nextTick(() => this.fitToScreen())
      }
    },
    _fallbackData() {
      return {
        charge_time: 1.5, charge_money: '2.50',
        pad_time: 1, pad_money: '3.90',
        chair_time: 1, chair_money: '9.00',
        all_times: 1, all_moneys: '12.00'
      }
    },
    // 增加数量（含互斥逻辑）
    incCount(type) {
      if (type === 'all') {
        // 选全套 → 清空其他三个
        this.chargeCount = 0
        this.padCount = 0
        this.chairCount = 0
        if (this.allCount < 5) this.allCount++
      } else {
        // 选任意单项 → 清空全套
        this.allCount = 0
        const key = type + 'Count'
        if (this[key] < 5) this[key]++
      }
    },
    // 减少数量
    decCount(type) {
      const key = type + 'Count'
      if (this[key] > 0) this[key]--
    },
    // 确认付款
    async handlePay() {
      if (this.totalAmount <= 0) return

      // 二次确认：弹框显示金额，点确认才调接口，点取消直接返回
      try {
        await this.$confirm(
          `支付金额：¥${this.totalAmount.toFixed(2)}`,
          '确认付款',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
            customClass: 'mobile-center-alert'
          }
        )
      } catch (e) {
        // 用户点取消，不调接口
        return
      }

      // 组装支付数据对象：各套餐的时间、金额、选中数量 + 总金额
      // 未选中的套餐（count 为 0），其时间和金额置为空字符串
      const payData = {
        // 手机充电
        charge_time: this.chargeCount > 0 ? this.moneyData.charge_time : 0,
        charge_money: this.chargeCount > 0 ? this.moneyData.charge_money : 0,
        charge_count: this.chargeCount,
        // 影视娱乐
        pad_time: this.padCount > 0 ? this.moneyData.pad_time : 0,
        pad_money: this.padCount > 0 ? this.moneyData.pad_money : 0,
        pad_count: this.padCount,
        // 座椅功能
        chair_time: this.chairCount > 0 ? this.moneyData.chair_time : 0,
        chair_money: this.chairCount > 0 ? this.moneyData.chair_money : 0,
        chair_count: this.chairCount,
        // 全套功能
        all_times: this.allCount > 0 ? this.moneyData.all_times : 0,
        all_moneys: this.allCount > 0 ? this.moneyData.all_moneys : 0,
        all_count: this.allCount,
        // 总金额
        total_amount: this.totalAmount.toFixed(2)
      }

      console.log('====== 支付数据 ======')
      console.log(JSON.stringify(payData, null, 2))
      console.log('======================')

      // this.$alert(
      //   `支付金额：¥${this.totalAmount.toFixed(2)}<br>手机充电×${this.chargeCount}，影视娱乐×${this.padCount}，座椅功能×${this.chairCount}，全套×${this.allCount}`,
      //   '确认付款',
      //   { customClass: 'mobile-center-alert', center: true }   
      // )
     axios({
        method: "post",
        url: "https://htapi.zxznzy.com/project/wx_pay_h5_adult_new",
        data: {
          equ_no: localStorage.getItem("equ_no"),
          equ_id: localStorage.getItem("text"),
          project_no: localStorage.getItem("project_no"),
          equ_price: this.totalAmount.toFixed(2), // 金额
          // open_minus: this.itemObj.time_one, // 时长
          price_type: "2", // 价格类型
          open_id: localStorage.getItem("open_id"),
          open_minus_all: JSON.stringify(payData),
          pad_no: localStorage.getItem("pad_no"),
        },
      })
        .then((response) => {
          if (response.data.code == 200) {
            // alert("获取支付参数" + JSON.stringify(response.data));
            this.onBridgeReady(response.data);
          } else {
            alert("支付接口返回异常请联系客服")
            // alert(JSON.stringify(response.data))
            console.error('接口返回异常', response.data)
            this.$message.error("error get opneid2");
            throw new Error(response.data.errmsg || "未知错误");
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    /* eslint-disable */
    async onBridgeReady(params) {
      try {
        // 添加请求超时处理
        const timer = setTimeout(() => {
          alert("支付超时，请刷新页面重试");
        }, 10000); // 10秒超时

        WeixinJSBridge.invoke("getBrandWCPayRequest", params, (res) => {
          clearTimeout(timer);

          if (res.err_msg === "get_brand_wcpay_request:ok") {
            // 跳转到订单列表
            this.$router.push({ path: "/new-page-order-list", query: { tab: 'second' } });
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            alert("您已取消支付，可到订单页面重新支付");
          } else {
            alert(`支付失败: ${res.err_msg || "未知错误"}`);
          }
        });
      } catch (error) {
        alert("系统繁忙，请稍后重试 (CODE:500)");
      }
    },

  }
}
</script>

<style scoped>
.money_list_page {
  width: 100vw;
  height: 100vh;
  background: #f5f8fc;
  overflow: hidden;
  box-sizing: border-box;
}
/* 内容缩放容器：小屏时整体等比缩小，保证一屏完整展示 */
.page_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  will-change: transform;
}

/* 顶部标题区 —— 图片本身已包含文字，直接 img 完整展示 */
.header {
  width: 100%;
  line-height: 0; /* 干掉 inline img 底部 4px 空隙 */
}
.header_bg {
  width: 100%;       /* 撑满视口宽度 */
  height: auto;      /* 高度按原图比例自动算 —— 绝不拉伸 */
  display: block;    /* 干掉 inline img 底部空隙 */
}

/* 安全提示 */
.safe_tip {
  margin: 10px 0 14px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.safe_icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  color: #2f7fd6;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

/* 加载态 */
.loading_tip { text-align: center; padding: 30px; color: #999; font-size: 14px; }

/* 功能列表 */
.opt_list {
  padding: 5px 15px;        /* 左右各留 15px 空隙 */
  margin-top: -14%;
  background-color: #1065c3;
  border-radius: 16px;    /* 四个角圆角 */
  position: relative; /* 创建定位上下文，盖在 header 的 img 之上 */
  z-index: 2;
  padding-bottom: 3%;
}
.opt_item {
  display: flex;
  align-items: center;
  gap: 30px;
  background: #fff;
  border-radius: 16px;
  padding: 14px 15px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: all 0.2s;
}
.opt_item.opt_disabled {
  opacity: 0.5;
  pointer-events: none;
}
/* 全套功能高亮：金色渐变卡片 */
.opt_item.opt_all {
  background: linear-gradient(135deg, #fff9e6, #fdf0c8);
  border: 1px solid #f2d68a;
  box-shadow: 0 2px 10px rgba(240, 190, 60, 0.25);
}

/* 左侧圆形图标 */
.opt_icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.opt_icon img {
  width: 110%;
  height: 110%;
  object-fit: contain;
  display: block;
}
.icon_charge { background: #e3f0fd; }
.icon_media { background: #efe6fb; }
.icon_chair { background: #e4f5e9; }
.icon_all { background: #fdeed3; }

.opt_content { flex: 1; min-width: 0; }
.opt_name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 6px;
}
.opt_tag {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 400;
  color: #999;
}
.opt_recommend {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 400;
  color: #fff;
  background: linear-gradient(135deg, #ff9d2e, #ff7a00);
  border-radius: 10px;
  padding: 2px 8px;
}
.opt_price {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
  margin-top: 2px;
}
.opt_price_num {
  font-size: 26px;
  color: #3586ff;
  font-weight: 700;
}
.opt_price_num.opt_price_long {
  font-size: 20px;
}
.opt_price_unit {
  font-size: 12px;
  color: #999;
  margin-left: 2px;
}
.opt_desc {
  display: inline-block;
  margin-top: 6px;
  font-size: 10px;
  white-space: nowrap;
  color: #b8860b;
  background: rgba(255, 214, 102, 0.35);
  border-radius: 10px;
  padding: 2px 10px;
}

/* 加减按钮 */
.opt_stepper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 1px;
  background-color: #ebf4fd;
  border-radius: 999px;
  padding: 2px;
}
.step_btn {
  width: 28px; height: 28px;
  border-radius: 4px;
  border: 1px solid #dfebfa;
  background: #dfebfa;
  color: #2c6ba5;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.step_btn:disabled {
  border: 1px solid #dfebfa;
  background: #dfebfa;
      cursor: not-allowed; 
    }
.step_btn:first-child {
  border-radius: 50% 0 0 50%;
}
.step_btn:last-child {
  border-radius: 0 50% 50% 0;
}
.step_num { width: 60px; text-align: center; font-size: 16px; font-weight: 600; color: #333; }

/* 底部结算栏 —— 蓝色圆角条 + 黄色按钮 */
.bottom_bar {
  bottom: 15px; left: 15px; right: 15px;
  background: linear-gradient(135deg, #2f8ae0, #1666c9);
  border-radius: 14px;
  padding: 8px 8px 8px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 16px rgba(21, 101, 192, 0.35);
  z-index: 99;
}
.total {
  flex: 1;
  font-size: 15px;
  color: #fff;
  font-weight: 500;
  display: flex;
  align-items: baseline;
}
.total_price {
  font-size: 22px;
  font-weight: 700;
  color: #ffe14d;
  margin-left: 2px;
}
.pay_btn {
  flex-shrink: 0;
  background: linear-gradient(135deg, #ffe27a, #ffd23f);
  color: #1a4b8f;
  border: none;
  border-radius: 10px;
  padding: 12px 26px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
}
.pay_btn:disabled {
  background: #f0e6b0;
  color: #8a8a8a;
  cursor: not-allowed;
}

/* 底部公司信息 —— 自动贴底 */
.company_footer {
  margin-top: auto;             /* 内容不足时推到页面底部 */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0px 15px 30px;
  background: #f5f8fc;
}
.qr_code {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  background: #fff;
  object-fit: contain;
  flex-shrink: 0;
}
.company_info {
  display: flex;
  flex-direction: column;
  gap: 3px;
  color: #666;
  font-size: 12px;
  line-height: 1;
}
.company_name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
</style>

<style>
/* element-ui MessageBox 移动端适配 —— 非 scoped，挂载在 body 上需穿透 */
.mobile-center-alert {
  width: calc(100% - 32px) !important;
  max-width: 360px !important;
  border-radius: 12px !important;
}
.mobile-center-alert .el-message-box__header {
  padding: 16px 16px 8px !important;
}
.mobile-center-alert .el-message-box__title {
  font-size: 16px !important;
}
.mobile-center-alert .el-message-box__content {
  padding: 8px 16px 16px !important;
  font-size: 15px !important;
  text-align: center !important;
}
.mobile-center-alert .el-message-box__btns {
  padding: 8px 16px 16px !important;
  display: flex;
  gap: 10px;
}
.mobile-center-alert .el-message-box__btns button {
  flex: 1;
  margin: 0 !important;
  padding: 10px 0 !important;
  font-size: 15px !important;
  border-radius: 8px !important;
}
</style>